import { render } from "./FormTransformation.vue?vue&type=template&id=5a67b9a6&scoped=true"
import script from "./FormTransformation.vue?vue&type=script&lang=js"
export * from "./FormTransformation.vue?vue&type=script&lang=js"

import "./FormTransformation.vue?vue&type=style&index=0&id=5a67b9a6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5a67b9a6"

export default script